import React from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

export default function RouteError() {
  const err = useRouteError() as any

  let title = 'Unexpected error'
  let detail = err?.message || String(err)

  if (isRouteErrorResponse(err)) {
    title = `${err.status} ${err.statusText}`
    detail = (err.data && (err.data.detail || err.data.message)) || detail
  }

  return (
    <div className="min-h-screen bg-zinc-950 text-white px-6 py-10">
      <div className="mx-auto max-w-xl">
        <div className="text-2xl font-extrabold">{title}</div>
        <div className="mt-2 text-white/70 text-sm">This page failed to load. Try again, or go back to Settings.</div>
        <div className="mt-4 rounded-xl border border-white/10 bg-white/5 p-4 text-sm text-white/80">{detail}</div>
        <div className="mt-5 flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="inline-flex items-center justify-center rounded-lg px-3 py-2 text-sm font-semibold transition border bg-sky-600 text-white border-sky-500/40 hover:bg-sky-500 hover:border-sky-400/50"
          >
            Refresh
          </button>
          <button
            type="button"
            onClick={() => window.location.assign('/settings')}
            className="inline-flex items-center justify-center rounded-lg px-3 py-2 text-sm font-semibold transition border bg-white/10 text-white border-white/15 hover:bg-white/15"
          >
            Go to Settings
          </button>
        </div>
      </div>
    </div>
  )
}

